export const TCPLogo = require('./images/TCPlogo.svg');
export const IconHome = require('./images/icon-home.svg');

export const IconProfile = require('./images/icon-profile.svg');
export const IconProfileActive = require('./images/icon-profile-active.png');
export const IconProfileEmptyUser = require('./images/icon-profile-user-empty.svg');
export const IconLogout = require('./images/icon-logout.svg');

export const IconContactAcitve = require('./images/icon-contact-active.svg');
export const IconContactInAcitve = require('./images/icon-contact-inactive.svg');
export const IconSummaryActive = require('./images/icon-summary-active.svg');
export const IconSummaryInActive = require('./images/icon-summary-inactive.svg');

export const IconCustomerNew = require('./images/icon-customer-new.svg');
export const IconCustomerEdit = require('./images/icon-customer-edit.svg');
export const IconCustomerReorder = require('./images/icon-customer-reorder.svg');
export const IconCustomerPre = require('./images/icon-customer-prequalify.svg');
export const IconCustomerHistory = require('./images/icon-customer-prequalify.svg');

export const IconDelete = require('./images/icon-delete.svg');
export const IconEnvelops = require('./images/icon-envelopes.svg');

export const IconStatusWaiting = require('./images/icon-status-waiting.svg');
export const IconStatusConfirmed = require('./images/icon-status-confirmed.svg');

export const iconPaid = require('./images/icon-paid.svg');
export const iconNotify = require('./images/icon-notify.svg');
export const IconSmallArrowRight = require('./images/icon-small-right-arrow.svg');
export const IconArrowLeft = require('./images/icon-arrow-left.svg');
export const IconSortInActive = require('./images/icon-sort-inactive.svg');
export const IconSortActive = require('./images/icon-sort-active.svg');
export const IconSearchInActive = require('./images/icon-search-inactive.svg');
export const IconSearchActive = require('./images/icon-search-active.svg');
export const IconFilterInActive = require('./images/icon-filter-inactive.svg');
export const IconFilterActive = require('./images/icon-filter-active.svg');
export const IconAwesomePaperPlaneSend = require('./images/Icon-awesome-paper-plane-send.svg'); 
export const IconAwesomePaperPlane = require('./images/Icon-awesome-paper-plane.svg'); 
export const IconAwesomePenFancy = require('./images/Icon-awesome-pen-fancy.svg'); 
export const IconAwesomePenFancyRight = require('./images/Icon-awesome-pen-fancy-right.svg'); 
export const IconEnvelopeClosed = require('./images/Icon-envelope-closed.svg'); 
export const IconEnvelopeOpen = require('./images/Icon-envelope-open.svg'); 
export const IconCaledar = require('./images/Icon-metro-calendar.svg');


export const IconFixIssueAwesomePaperPlane = require('./images/fix-issues/Icon-awesome-paper-plane.svg');
export const IconFixIssueEnvelopeOpen = require('./images/fix-issues/Icon-open-envelope.svg');
export const IconFixIssueAwesomePenFancy = require('./images/fix-issues/Icon-awesome-pen-fancy-writen.svg');
export const IconFixIssueEnvelopeClosed = require('./images/fix-issues/Icon-closed-envelope.svg');
export const IconFixIssueAwesomePenFancyRight = require('./images/fix-issues/Icon-awesome-pen-fancy.svg');
export const IconFixIssueAwesomeSendRed = require('./images/fix-issues/Icon-awesome-paper-plane-red.svg');

export const IconDashboardSales = require('./images/icon-dashboard-sales.svg');
export const IconDashboardStaff = require('./images/icon-dashboard-staff.svg');
export const IconDashboardSalesApp = require('./images/icon-dashboard-cart.svg');
export const IconDashboardPending = require('./images/icon-dashboard-pending.svg');
export const IconDashboardDeclined = require('./images/icon-dashboard-declined.svg');
export const IconDashboardApproved = require('./images/icon-dashboard-approved.svg');
export const IconDashboardFunded = require('./images/icon-dashboard-funded.svg');
export const IconDashboardCanceled = require('./images/icon-dashboard-canceled.svg');
export const IconDashboardPreApprovals = require('./images/icon-dashboard-preapprovals.svg');
export const IconDashboardIncomplete = require('./images/icon-dashboard-incomplete.svg');

export const IconPreapprovalWaiting = require('./images/icon-preapproval-waiting.svg');
export const IconPreapprovalDeclined = require('./images/icon-preapproval-declined.svg');
export const IconTrash = require('./images/icons8-trash.svg');

export const UnderConstruction = require('./images/underconst.svg')